// API client for users management
const API_BASE_URL = 'https://dlbackend.dlappstudio.com/api/v1';
//const API_BASE_URL = 'http://localhost:4000/api/v1/users';
//const API_BASE_URL = 'http://192.168.100.117:4000/api/v1/users';

export async function getAllProducts() {
  try {
    const response = await fetch(`${API_BASE_URL}/operations/product/getProducts`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    return response.json();
  } catch (error) {
    console.error('Error fetching products:', error);
    return { success: false, error: error.message };
  }
}

export async function updateProduct(productId, productData) {
  try {
    const response = await fetch(`${API_BASE_URL}/operations/product/update/${productId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(productData)
    });

    const responseText = await response.text();
    let parsedResponse = null;

    if (responseText) {
      try {
        parsedResponse = JSON.parse(responseText);
      } catch {
        parsedResponse = { message: responseText };
      }
    }

    if (!response.ok) {
      return {
        success: false,
        status: response.status,
        ...(parsedResponse || {})
      };
    }

    return parsedResponse || { success: true };
  } catch (error) {
    console.error('Error updating product:', error);
    return { success: false, error: error.message };
  }
}

export async function deleteProduct(productId) {
  try {
    const response = await fetch(`${API_BASE_URL}/operations/product/deleteProduct/${productId}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    });
    return response.json();
  } catch (error) {
    console.error('Error deleting product:', error);
    return { success: false, error: error.message };
  }
}

export async function createProduct(productData) {
  try {
    const response = await fetch(`${API_BASE_URL}/operations/product/createProduct`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(productData)
    });
    return response.json();
  } catch (error) {
    console.error('Error creating this product:', error);
    return { success: false, error: error.message };
  }
}

